module.exports = "<div class=modal data-backdrop=false tabindex=-1 role=dialog aria-hidden=false> <div class=modal-dialog> <div class=modal-content> <div class=modal-header ng-show=title> <h4 class=modal-title><i class=\"fa fa-key text-muted\"></i> {{::title}}</h4> </div> <div class=modal-body ng-bind-html=::content> </div> <div class=modal-footer> <button type=button class=\"btn btn-default btn-success\" ng-click=fecharModal() aria-label=Close>Ok, Entendi!</button> </div> </div> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/modules/autenticacao/modal-recuperar-senha.html
// module id = 265
// module chunks = 1